import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { OktaAuthModule, OKTA_CONFIG } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AgGridModule } from 'ag-grid-angular';
import { environment } from 'src/environments/environment';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { FileUploadComponent } from './shared/components/file-upload/file-upload.component';
import { CoreModule } from './core/core.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { ErrorComponent } from './errors/error/error.component';
import { TokenInterceptors } from './core/interceptors/token-interceptors';
import { LoaderInterceptor } from './core/interceptors/loader.interceptor';
import { EmailActionComponent } from './shared/components/email-action/email-action.component';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { UsercogformComponent } from './shared/components/usercogform/usercogform.component';
import { EmailCognitoFormComponent } from './shared/components/usercogform/email-cognito-form/email-cognito-form.component';

const oktaAuth = new OktaAuth(environment.oktaConfig);
@NgModule({ 
    declarations: [
        AppComponent,
        MaintenanceComponent,
        FileUploadComponent,
        ErrorComponent,
        EmailActionComponent,
        UsercogformComponent,
        EmailCognitoFormComponent
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], 
    imports: [BrowserModule,
        OktaAuthModule.forRoot({ oktaAuth }),
        AppRoutingModule,
        CoreModule,
        AgGridModule,
        NgbModule,
        CommonModule], 
    providers: [
        { provide: OKTA_CONFIG, useValue: { oktaAuth } },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptors, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }, 
        provideHttpClient(withInterceptorsFromDi())
    ]})
export class AppModule { }
